import { User, SystemRole } from "./User";
import { OrganizationResponse } from "./OrganizationModels";
import type { RoleDetail } from "./UserProfileResponse";

export enum RoleType {
  PlatformOwner = 1,
  OrganizationOwner = 2,
  Admin = 3,
  Manager = 4,
  Receptionist = 5,
  Staff = 6,
}

export interface InviteUserRequest {
  email: string;
  userName?: string;
  contact?: string;
  organizationId: string;
  roleType?: RoleType;
  roleName?: string;
  order?: number;
  designation?: string;
  qualification?: string;
  bio?: string;
  isPublic?: boolean;
  profilePictureFile?: File | null;
}

export interface UpdateUserOrganizationRequest {
  roleType?: RoleType;
  roleName?: string;
  userName?: string;
  userId?: string;
  order?: number;
  designation?: string;
  qualification?: string;
  bio?: string;
  isPublic?: boolean;
  profilePictureUrl?: string;
  profilePictureFile?: File | null;
}

export interface UserListResult {
  items: User[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface UserOrganizationDetails extends OrganizationResponse {
  userOrganizationId: string;
  organizationId: string;
  roleType: RoleType;
  roleName: string;
  designation?: string | null;
  qualification?: string | null;
  bio?: string | null;
  order?: number;
  profilePictureUrl?: string | null;
  role: RoleDetail;
  isDefault: boolean;
  membershipStatus: string;
  invitationExpires: string | null;
  branches: unknown[] | null;
}

export interface UserDetailsResponse {
  id: string;
  email: string;
  contact: string;
  userName: string;
  isEmailVerified: boolean;
  isMfaEnabled: boolean;
  isActive: boolean;
  systemRole: SystemRole;
  organizations: UserOrganizationDetails[];
}